/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import withLayout from '../../../core/components/with-layout';

import Tabs from '../../constants/tabs';

import {
  Button,
  Container,
  Header,
  Segment,
  Text,
  Video,
  VideoContainer,
  ButtonArea,
  Link,
} from './styles';

const faqsUrl = 'http://help.playbookux.com/en/articles/3908786-tester-faqs';
const videoUrl = 'https://player.vimeo.com/video/674640426?h=ab624950bf&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479';

const VideoInstruction = (props) => {
  const { history } = props;

  const handleButtonClick = () => {
    history.push('/practice-test-instructions');
  };

  return (
    <Container>
      <Segment>
        <Header as="h3">
          Thanks for signing up! You’re one step closer to taking part in paid research studies.
        </Header>

        <Text>
          Watch this video to learn how to take studies with PlaybookUX.
          There are multiple types of studies - which means more ways to earn money!
        </Text>

        <VideoContainer>
          <Video src={videoUrl} frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen title="Participant sign up video" />
        </VideoContainer>

        <ButtonArea>
          <Button onClick={handleButtonClick}>
            Next
          </Button>

          <Link href={faqsUrl} target="_blank">
            Check out our FAQs about testing with PlaybookUX here
          </Link>
        </ButtonArea>
      </Segment>
    </Container>
  );
};

VideoInstruction.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default compose(withLayout({ selectedTab: Tabs.VIDEO_INSTRUCTION }))(VideoInstruction);
